export default __webpack_public_path__ + "static/media/PKN.a3b23174.png";